import { AlertController, MenuController } from '@ionic/angular';
import { HestiaUserFacade, userActions } from '@hestia/ngx-user';

import { Component } from '@angular/core';
import { DawbaRoutes } from './route-constants';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'dawba-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  selectedLang = this.transloco.getDefaultLang();

  constructor(
    public userFacade: HestiaUserFacade,
    private alertCtrl: AlertController,
    private menuCtrl: MenuController,
    private transloco: TranslocoService,
    private router: Router
  ) {}

  langChanged(ev: any) {
    this.transloco.setActiveLang(ev.detail.value);
  }

  public async goToDashboard(): Promise<void> {
    await this.menuCtrl.close();
    this.router.navigate(['/', DawbaRoutes.DashboardPage]);
  }

  public async goToOnboarding(): Promise<void> {
    await this.menuCtrl.close();
    this.router.navigate(['/', DawbaRoutes.OnboardingPage]);
  }

  public async triggerLogoutAlert(): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: this.transloco.translate('appMenu.logoutAlert.header'),
      message: this.transloco.translate('appMenu.logoutAlert.message'),
      buttons: [
        {
          text: this.transloco.translate('appMenu.logoutAlert.cancelBtn'),
          role: 'cancel',
          handler: () => {},
        },
        {
          text: this.transloco.translate('appMenu.logoutAlert.confirmBtn'),
          role: 'destructive',
          handler: async () => {
            this.menuCtrl.close();
            await this.userFacade.initLogout();
          },
        },
      ],
    });
    alert.present();
  }
}
